var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1174,
    height: 1176,
    viewBox: "0 0 1174 1176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 586.997,
    cy: 588,
    rx: 586.997,
    ry: 588,
    fill: "#E8EAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseMask);
export default __webpack_public_path__ + "static/media/Ellipse_mask.60e58f0186133a54bd3811dab909adf4.svg";
export { ForwardRef as ReactComponent };